// Opens gallery images (gallery.html) full size in GLightbox: previous /
// next, close button, keyboard (← → Esc) and touch swipe.
//
// Markup contract, so WordPress can output it from the Media Library:
//   <a href="FULL_SIZE_URL" class="glightbox" data-gallery="GROUP"
//      data-title="CAPTION"><img src="THUMB_URL" alt="…"></a>
// Links sharing a data-gallery value page through together.
import GLightbox from 'glightbox';

export function initGalleryLightbox() {
  if (!document.querySelector('.glightbox')) return;

  GLightbox({
    selector: '.glightbox',
    touchNavigation: true,
    keyboardNavigation: true,
    closeButton: true,
    loop: true,
  });
}
